module.exports = __webpack_public_path__ + "static/media/kph.7164ba42.png";